import {AxiosRequestConfig} from 'axios';
import {LoginReq} from '../types';

export const login = (data: LoginReq): AxiosRequestConfig => ({
	method: 'POST',
	url: '/login',
	data
});